import { Shield, RotateCcw, Lock, Mountain } from "lucide-react";

// Benefit bar (Ref 2/3). Copy is deliberately factual — no unverified returns/conservation
// promises until HomeRange configures real policies (Phase 4 store settings).
const ITEMS = [
  { icon: Shield, title: "BUILT TO LAST", body: "Quality gear made for the long haul." },
  { icon: RotateCcw, title: "EASY RETURNS", body: "Not right? Reach out and we'll help sort it." },
  { icon: Lock, title: "SECURE CHECKOUT", body: "Payments processed securely by Stripe." },
  { icon: Mountain, title: "LIVE THE RANGE", body: "Gear for the field, camp, and everywhere between." },
];

export function BenefitBar({ dark }) {
  return (
    <section className={`${dark ? "bg-forest text-bone grain" : "bg-bone text-charcoal border-t border-charcoal/10"} px-5 sm:px-10 py-12`} data-testid="benefit-bar">
      <div className="max-w-[1400px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-8">
        {ITEMS.map((it) => (
          <div key={it.title} className="text-center">
            <it.icon size={26} className={`mx-auto ${dark ? "text-blaze" : "text-saddle"}`} strokeWidth={1.4} />
            <p className="hr-overline mt-3 text-blaze">{it.title}</p>
            <p className={`text-sm mt-1.5 ${dark ? "text-bone/60" : "text-charcoal/55"}`}>{it.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
